import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import utils from '../../utils';
import { PLATFORM } from '../../constants';
var Ainsworth = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Ainsworth(args) {
    var _this;
    _classCallCheck(this, Ainsworth);
    _this = _callSuper(this, Ainsworth, [args]);
    /**
     * Ainsworth Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.jsonParserEvent = function (payload) {
      var _store$getState$playe = store.getState().playerInfo,
        playerId = _store$getState$playe.playerId,
        soundEffects = _store$getState$playe.soundEffects;
      var gameId = store.getState().gameInfo.gameId;
      var currentBalance = store.getState().coin.value;
      if (soundEffects !== _this.currentSoundSetting) {
        _this.setSound();
      }
      var name = payload.name,
        data = payload.data;
      switch (name) {
        case 'gameReady':
          if (data.isReady) {
            _this.sendAnalyticEvent();
            _this._gameReady();
            _this.setDefaultBet();
            _this.setSound();
          }
          break;
        case 'gameStart':
          _this.DebitCoins(data.totalBet);
          _this._currentBet = parseInt(data.totalBet);
          store.dispatch(setSpinEvent({
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WAGE,
            amount: data.totalBet,
            gameId: gameId,
            balanceBefore: currentBalance,
            balanceAfter: currentBalance - data.totalBet
          }));
          _this.syncCoinsBalance(currentBalance - data.totalBet);
          _this.AddSpinXP(data.totalBet);
          break;
        case 'gameEnd':
          if (data.totalWon > 0) {
            _this.CreditCoins(data.totalWon);
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WIN,
              gameId: gameId,
              amount: data.totalWon,
              balanceAfter: currentBalance + data.totalWon
            }));
            _this.syncCoinsBalance(currentBalance + data.totalWon);
            if (parseInt(data.totalWon) >= 10 * _this._currentBet && !utils.isWebOrMobileWeb()) _this.showRateUsScreen();
          }
          break;
        case 'outOfCoins':
          {
            _this._outOfCoins();
            _this.showOutOfCoinsScreen();
            break;
          }
        case 'error':
          {
            var errorDescription = JSON.stringify(data);
            _this.sendErrorCreatedEvent(errorDescription);
            break;
          }
        default:
          break;
      }
    };
    _this._currentBet = 0;
    _this.currentSoundSetting = false;
    return _this;
  }
  _inherits(Ainsworth, _GameInterface);
  return _createClass(Ainsworth, [{
    key: "setDefaultBet",
    value: function setDefaultBet() {
      var defaultBet = this._betInfo.increments[this._betInfo.index];
      this.sendEvent(JSON.stringify({
        name: 'betLevels',
        data: {
          coins: this._betInfo.increments,
          currentBet: defaultBet
        }
      }));
    }
  }, {
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent(JSON.stringify({
        name: 'volumeUpdate',
        data: {
          volume: soundEffects
        }
      }));
      this.currentSoundSetting = soundEffects;
    }
  }]);
}(GameInterface);
export default Ainsworth;